import type { DriverActivityFormValues } from './types'
import { Divider } from '@mui/material'
import { useMemo } from 'react'
import { FormConfig } from '@workwave-tidal/core/form'
import { useTexts } from './hooks/useTexts'
import { ReasonFields } from './ReasonFields'
import { useOnSubmit } from './hooks/useOnSubmit'
import { StartEndRoute } from './StartEndRoute/StartEndRoute'
import { DynamicLoadsCf } from './DynamicLoadsCf/DynamicLoadsCf'
import { form } from './formState'
import { FormFooter } from './FormFooter'
import { ReasonsForNotCompletedOrdersFormHeader } from './ReasonsForNotCompletedOrdersFormHeader'

type Props = {
  initialValues: DriverActivityFormValues
}

export function DriverActivityForm(props: Props) {
  const { initialValues } = props

  const texts = useTexts()

  const onSubmit = useOnSubmit()

  const config = useMemo<FormConfig<DriverActivityFormValues>>(
    () => ({
      id: 'driver-activity-form',
      initialValues: initialValues,
    }),
    [],
  )

  return (
    <form.Form
      title={texts.headerTitle}
      subtitle={texts.headerDescription}
      footer={<FormFooter />}
      onSubmit={onSubmit}
      config={config}
      requireTransaction={false}
      stopEditingOnUnmount
      applyPendingFitMapOnMount={false}
      testId="driver-activity-form"
    >
      <StartEndRoute />
      <Divider />
      <DynamicLoadsCf />
      <Divider />
      <div data-testid="reason-for-not-completed-orders-field">
        <ReasonsForNotCompletedOrdersFormHeader />
        <ReasonFields />
      </div>
    </form.Form>
  )
}
